export default __webpack_public_path__ + "static/media/globe.276c31cf.png";